const SINGLE_CURLY_QUOTE_REGEX = /[\u2018\u2019]/g;
const DOUBLE_CURLY_QUOTE_REGEX = /[\u201C\u201D]/g;

export const normalizeQuotes = (text: string): string => {
  return text
    .replace(SINGLE_CURLY_QUOTE_REGEX, "'")
    .replace(DOUBLE_CURLY_QUOTE_REGEX, '"');
};

export const convertToSnakeCase = (input: string): string => {
  return input
    .toLowerCase()
    .trim()
    .replace(/[\s-]+/g, '_')
    .replace(/^_+|_+$/g, '');
};

export const getDisplayedNameText = (
  displayName: string | null | undefined,
  name: string | null | undefined,
): string => {
  return displayName || name || '';
};
